import React from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Header from '../../components/Headers/Header';
import Carousel from './Carousel';

const useStyles = makeStyles(theme => ({
  form: {
    //height: '92vh',
    minHeight:570,
    maxHeight: 1080,
    [theme.breakpoints.down(1360)]: {
      maxHeight: 768
    }
  }
}));

const SignUpLayout = props => {
  const classes = useStyles();
  const breakpoint = useMediaQuery('(min-width:768px)');

  return (
    <>
      <Header />
      <Container maxWidth="xl" style={{ paddingLeft: 0, paddingRight: 0 }}>
        <Grid container>
          {breakpoint && (
            <Grid item xs={6}>
              <Carousel />
            </Grid>
          )}
          <Grid item xs={breakpoint ? 6 : 12} className={classes.form}>
            {props.children}
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default SignUpLayout;
